import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/base.css';

console.log('[Memory Hub] Bootstrap: Starting application...');

// Global error capture to debug "blank page" issues
window.onerror = (message, source, lineno, colno, error) => {
  console.error('[Memory Hub] Global Error Captured:', { message, source, lineno, colno, error });
  return false;
};

window.onunhandledrejection = (event) => {
  console.error('[Memory Hub] Unhandled Promise Rejection:', event.reason);
};

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('[Memory Hub] Bootstrap: Critial Error - #root element not found in DOM!');
} else {
  console.log('[Memory Hub] Bootstrap: Found root element, rendering App...');
  try {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    console.log('[Memory Hub] Bootstrap: render() called successfully.');
  } catch (err) {
    console.error('[Memory Hub] Bootstrap: Rendering crash:', err);
  }
}
